var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaugh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "laugh",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8Zm8.065,15.323a3.226,3.226,0,1,1-3.226,3.226A3.222,3.222,0,0,1,33.065,23.323Zm-16.129,0a3.226,3.226,0,1,1-3.226,3.226A3.222,3.222,0,0,1,16.935,23.323Zm8.871,27.419H24.194A14.529,14.529,0,0,1,9.788,38.04a1.619,1.619,0,0,1,1.6-1.815H38.609a1.614,1.614,0,0,1,1.6,1.815A14.529,14.529,0,0,1,25.806,50.742Z",
    transform: "translate(0 -8)",
    fill: "#36ab80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaugh);
export default __webpack_public_path__ + "static/media/laugh.5715ff322f94fe749a08179346cff880.svg";
export { ForwardRef as ReactComponent };